/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReceivedMessage } from './ReceivedMessage';
import {
    ReceivedMessageFromJSON,
    ReceivedMessageFromJSONTyped,
    ReceivedMessageToJSON,
} from './ReceivedMessage';

/**
 * 
 * @export
 * @interface ReceivedMessagesResponse
 */
export interface ReceivedMessagesResponse {
    /**
     * 
     * @type {string}
     * @memberof ReceivedMessagesResponse
     */
    begin?: string;
    /**
     * 
     * @type {string}
     * @memberof ReceivedMessagesResponse
     */
    end?: string;
    /**
     * 
     * @type {number}
     * @memberof ReceivedMessagesResponse
     */
    latest?: number;
    /**
     * 
     * @type {Array<ReceivedMessage>}
     * @memberof ReceivedMessagesResponse
     */
    records?: Array<ReceivedMessage>;
}

/**
 * Check if a given object implements the ReceivedMessagesResponse interface.
 */
export function instanceOfReceivedMessagesResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReceivedMessagesResponseFromJSON(json: any): ReceivedMessagesResponse {
    return ReceivedMessagesResponseFromJSONTyped(json, false);
}

export function ReceivedMessagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceivedMessagesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'begin': !exists(json, 'begin') ? undefined : json['begin'],
        'end': !exists(json, 'end') ? undefined : json['end'],
        'latest': !exists(json, 'latest') ? undefined : json['latest'],
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ReceivedMessageFromJSON)),
    };
}

export function ReceivedMessagesResponseToJSON(value?: ReceivedMessagesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'begin': value.begin,
        'end': value.end,
        'latest': value.latest,
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ReceivedMessageToJSON)),
    };
}

